import Marquee from "react-fast-marquee";
import { motion } from "framer-motion";
import { Star } from "lucide-react";
import { reviews } from "@/data/reviews";

export default function Reviews() {
  return (
    <section className="py-16 sm:py-20 border-t border-white/10 overflow-hidden" data-testid="reviews-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 mb-10">
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="font-script text-2xl text-[#6EB000] mb-2"
        >
          Ils m'ont fait confiance
        </motion.p>
        <h2 className="font-display text-3xl sm:text-5xl text-white">Avis clients</h2>
      </div>
      <Marquee speed={30} pauseOnHover gradient={false}>
        {reviews.map((r, i) => (
          <div
            key={i}
            className="w-80 sm:w-96 mx-3 bg-[#343A3D] border border-[#454C50] hover:border-[#6EB000]/50 transition-colors p-6 shrink-0"
            data-testid={`review-card-${i}`}
          >
            <div className="flex gap-1 mb-4">
              {Array.from({ length: r.rating }).map((_, j) => (
                <Star key={j} className="w-4 h-4 fill-[#F5A623] text-[#F5A623]" />
              ))}
            </div>
            <p className="text-white/70 text-sm leading-relaxed">« {r.text} »</p>
            <div className="mt-5 flex items-center justify-between">
              <span className="font-display text-white text-sm">{r.name}</span>
              <span className="text-[#6EB000] text-xs uppercase tracking-widest">{r.car}</span>
            </div>
          </div>
        ))}
      </Marquee>
    </section>
  );
}
